import { getTheme } from './getTheme';

const { LogoImage, LogoImageAuth } = getTheme();

export { LogoImage, LogoImageAuth };
